angular

	.module 'App.Repository'
	.factory 'PromotionEligibleSetsRepository', ['BaseRepository', (BaseRepository) ->
		class PromotionEligibleSetsRepository extends BaseRepository
			@resource = '/promotion_eligible_sets'
			@isRestricted = true

			loadByPromotionCampaignId: (campaignId) ->
				query = @createQuery()

				query.criteria 'promotion_campaign_id', '=', campaignId
				query.with 'qualification'
				query.with 'eligible_products'
				query.with 'eligible_product_categories'
				query.with 'eligible_product_categories>product_category'
				query.with 'eligible_products>products'
				query.with 'eligible_products>products>product_variants'
				query.with 'eligible_products>products>product_categories'
				query.with 'eligible_products>product_variants'

				return @getEntities query

		return new PromotionEligibleSetsRepository()
	]
